import type { SubscriptionTier } from '../constants/tiers';

export type Feature =
  | 'full_diagnostic'
  | 'upload'
  | 'additional_upload'
  | 'tutor'
  | 'unlimited_tutor'
  | 'voice_tutor'
  | 'pdf_export_map'
  | 'exports_all'
  | 'analytics'
  | 'priority_processing'
  | 'team_reports';

// Note: 'pdf_export_map' is the Learner-tier "PDF map" export (pricing matrix);
// 'exports_all' (Pro+) unlocks every export format. Pro/Teams hold both.
const TIER_FEATURES: Record<SubscriptionTier, Feature[]> = {
  free: ['upload', 'tutor'],
  learner: ['full_diagnostic', 'upload', 'additional_upload', 'tutor', 'pdf_export_map'],
  pro: ['full_diagnostic', 'upload', 'additional_upload', 'tutor', 'unlimited_tutor', 'voice_tutor', 'pdf_export_map', 'exports_all', 'analytics', 'priority_processing'],
  teams: ['full_diagnostic', 'upload', 'additional_upload', 'tutor', 'unlimited_tutor', 'voice_tutor', 'pdf_export_map', 'exports_all', 'analytics', 'priority_processing', 'team_reports'],
};

export function hasFeature(tier: SubscriptionTier, feature: Feature): boolean {
  return TIER_FEATURES[tier].includes(feature);
}

export function getMinimumTier(feature: Feature): SubscriptionTier {
  const tiers: SubscriptionTier[] = ['free', 'learner', 'pro', 'teams'];
  for (const tier of tiers) {
    if (TIER_FEATURES[tier].includes(feature)) return tier;
  }
  return 'teams';
}

export function isPaidTier(tier: SubscriptionTier): boolean {
  return tier !== 'free';
}
